import { AxiosResponse } from "axios";
import { api } from "../api";
import {
  AvailableCourse,
  AvailableCoursesFilters,
  DosificationConfiguration,
  SetSlotCoursesRequest,
} from "./school-dosification.types";

const schoolProgramPath = (schoolId: number, programId: number) =>
  `/school-dosification/schools/${schoolId}/programs/${programId}`;

export const getDosificationConfiguration = async (
  schoolId: number,
  programId: number,
  trimester: number
): Promise<DosificationConfiguration> => {
  const response: AxiosResponse<DosificationConfiguration> = await api.get(
    schoolProgramPath(schoolId, programId),
    { params: { trimester } }
  );
  return response.data;
};

export const getAvailableCourses = async (
  programId: number,
  filters: AvailableCoursesFilters = {}
): Promise<AvailableCourse[]> => {
  const response: AxiosResponse<AvailableCourse[]> = await api.get(
    `/school-dosification/programs/${programId}/available-courses`,
    { params: filters }
  );
  return response.data;
};

/** SCRUM-1076: replaces every course of one week, in the given order. */
export const setDosificationSlotCourses = async (
  schoolId: number,
  programId: number,
  data: SetSlotCoursesRequest
): Promise<void> => {
  await api.put(
    `${schoolProgramPath(schoolId, programId)}/slot/courses`,
    data
  );
};

/** SCRUM-1534: creates the next consecutive week, empty, in the last trimester. */
export const addDosificationWeek = async (
  schoolId: number,
  programId: number
): Promise<{ trimester: number; week: string }> => {
  const response: AxiosResponse<{ trimester: number; week: string }> =
    await api.post(`${schoolProgramPath(schoolId, programId)}/weeks`);
  return response.data;
};

export const restoreEmmiDosification = async (
  schoolId: number,
  programId: number
): Promise<{ restored: number }> => {
  const response: AxiosResponse<{ restored: number }> = await api.delete(
    schoolProgramPath(schoolId, programId)
  );
  return response.data;
};
